<template>
    <div>
        <v-col cols="12">
            <v-row>
                <v-col cols="4">
                    <v-menu
                        ref="createdDatePicker"
                        v-model="createdDatePicker"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        persistent
                        offset-y
                        min-width="290px"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="dateRangeText"
                                label="Report Time Range"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                outlined
                                hide-details
                                dense>
                            </v-text-field>
                        </template>
                        <v-date-picker
                            v-model="dates"
                            range
                            scrollable
                            @change="
                                showProductReport = false;
                                showProductFBSummaryReport = false;
                                showProductFBDayByDayReport = false;
                                showGGCampPerformReport = false;"
                            v-if="createdDatePicker">
                        </v-date-picker>
                    </v-menu>
                </v-col>

                <v-col cols="2">
                    <v-btn color="success" v-if="dates.length > 1" @click="loadData">Show Data</v-btn>
                    <v-btn v-else disabled>Show Data</v-btn>
                </v-col>

                <v-col cols="12">

                    <v-col cols="12">
                        <v-row>
                            <v-col cols="2">
                                <v-text-field label="Search..." outlined dense v-model="filter.search" @keyup="filterData"></v-text-field>
                            </v-col>

                            <v-col cols="2">
                                <v-select
                                :items="listIdeas"
                                label="Idea"
                                v-model="filter.byIdea"
                                :item-text="(obj) => obj.name"
                                :item-value="(obj) => obj.username"
                                outlined dense
                                @change="filterData"
                                ></v-select>
                            </v-col>

                            <v-col cols="2">
                                <v-select
                                :items="listProductTypes"
                                label="Product Type"
                                v-model="filter.byProductType"
                                :item-text="(obj) => obj.product_type"
                                :item-value="(obj) => obj.product_type"
                                @change="filterData"
                                outlined dense></v-select>
                            </v-col>

                            <v-col cols="2">
                                <v-autocomplete
                                    :items="listNiches"
                                    :item-text="(obj) => obj.tag_name"
                                    :item-value="(obj) => obj._id"
                                    label="Niche"
                                    v-model="filter.byNiche"
                                    @change="filterData"
                                    outlined dense
                                ></v-autocomplete>
                            </v-col>

                            <v-col cols="2">
                                <v-select
                                :items="listStatus"
                                label="Status"
                                v-model="filter.byStatus"
                                outlined dense
                                @change="filterData"
                                multiple
                                ></v-select>
                            </v-col>

                            <v-col cols="2">
                                <v-btn @click="clearFilter">Clear</v-btn>
                            </v-col>

                            <!-- <v-divider class="mx-4" inset vertical></v-divider> -->
                        </v-row>
                    </v-col>

                    <v-simple-table fixed-header height="95vh">
                        <template v-slot:default>
                            <thead>
                                <tr>
                                    <th class="cell-border"><div class="resize-div">Create Date</div></th>
                                    <th class="cell-border"><div class="resize-div">Product Type</div></th>
                                    <th class="cell-border"><div class="resize-div">Product Niche</div></th>
                                    <th class="cell-border"><div class="resize-div">Product Title</div></th>
                                    <th class="cell-border"><div class="resize-div">Product Code</div></th>
                                    <th class="cell-border"><div class="resize-div">Idea</div></th>
                                    <th class="cell-border"><div class="resize-div">Status</div></th>
                                    <th class="cell-border"><div class="resize-div">FB Campaign Name</div></th>
                                    <th class="cell-border"><div class="resize-div">Product Link</div></th>
                                    <th class="cell-border"><div class="resize-div">Social Network Service</div></th>
                                    <th class="cell-border">Post ID</th>
                                    <!-- <th class="cell-border" @click="sortData('post_id')">Post ID
                                        <v-icon x-small v-if="sortBy == 'post_id' && !sortType">mdi-arrow-up</v-icon>
                                        <v-icon x-small v-else-if="sortBy == 'post_id' && sortType">mdi-arrow-down</v-icon>
                                        <v-icon x-small v-else>mdi-arrow-up-down</v-icon>
                                    </th> -->
                                    <th class="cell-border"><div class="resize-div">Marketing Note</div></th>
                                    <th class="cell-border"><div class="resize-div">Banner Link</div></th>
                                    <th class="cell-border"><div class="resize-div">Job Note</div></th>
                                    <th class="cell-border"><div class="resize-div">Scaler</div></th>
                                    <th class="cell-border"><div class="resize-div">Uploader</div></th>
                                    <th class="cell-border"><div class="resize-div">Post User</div></th>
                                </tr>
                            </thead>

                            <tbody>
                                <template v-for="(item,index) of ideaReports">
                                    <tr :key="index">
                                        <td class="cell-border" :rowspan="item.jobs.length">
                                            {{ item.created_date }}
                                        </td>
                                        <td class="cell-border" :rowspan="item.jobs.length">
                                            {{ item.product_type_name }}
                                        </td>
                                        <td class="cell-border" :rowspan="item.jobs.length">
                                            {{ item.niches.join(", ") }}
                                        </td>
                                        <td class="cell-border" :rowspan="item.jobs.length">
                                            {{ item.product_title }}
                                        </td>
                                        <td class="cell-border" :rowspan="item.jobs.length">
                                            {{ item.product_code }}
                                        </td>
                                        <td class="cell-border" :rowspan="item.jobs.length">
                                            {{ item.idea }}
                                        </td>
                                        <td class="cell-border" :rowspan="item.jobs.length">
                                            {{ item.status }}
                                        </td>
                                        <td class="cell-border">
                                            <template v-if="item.jobs[0].fb_campaign_name">                                            
                                                    <v-btn
                                                    v-clipboard="item.jobs[0].fb_campaign_name"
                                                    @click="onCopy">
                                                    COPY
                                                </v-btn>
                                            </template>
                                        </td>
                                        <td class="cell-border">
                                            <template v-if="item.jobs[0].product_link">                                            
                                                    <v-btn
                                                    v-clipboard="item.jobs[0].product_link"
                                                    @click="onCopy">
                                                    COPY
                                                </v-btn>
                                            </template>
                                        </td>
                                        <td class="cell-border">
                                            {{ item.jobs[0].page }}
                                        </td>
                                        <td class="cell-border">
                                            {{ item.jobs[0].post_id }}
                                        </td>
                                        <td class="cell-border">
                                            <!-- <v-text-field v-model="item.jobs[0].marketing_note"></v-text-field>
                                            {{ item.jobs[0].marketing_note }} -->

                                            <v-edit-dialog
                                                :return-value.sync="item.jobs[0].marketing_note"
                                                @save="save(item,0,item.jobs[0].marketing_note)"
                                                @cancel="cancel"
                                                @open="open"
                                                @close="close"
                                                >
                                                {{ item.jobs[0].marketing_note }}
                                                <template v-slot:input>
                                                    <v-text-field
                                                    v-model="item.jobs[0].marketing_note"
                                                    label="Edit"
                                                    single-line
                                                    counter
                                                    ></v-text-field>
                                                </template>
                                            </v-edit-dialog>
                                        </td>
                                        <td class="cell-border">
                                            <template v-if="item.jobs[0].banner_link">
                                                <v-btn
                                                    v-clipboard="item.jobs[0].banner_link"
                                                    @click="onCopy">
                                                    COPY
                                                </v-btn>
                                            </template>
                                        </td>
                                        <td class="cell-border">

                                            <v-menu
                                            :close-on-content-click="false"
                                            :nudge-width="200"
                                            offset-x
                                            persistent
                                            v-if="item.jobs[0].job_note"
                                            >
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn  v-bind="attrs" v-on="on">
                                                        SHOW NOTE
                                                    </v-btn>
                                                </template>
                                                <v-card class="mx-auto" max-width="344" outlined>
                                                    {{ item.jobs[0].job_note }}
                                                </v-card>
                                            </v-menu>

                                            <!-- {{ item.jobs[0].job_note }} -->
                                        </td>
                                        <td class="cell-border cell-color">
                                            {{ item.jobs[0].scaler }}
                                        </td>
                                        <td class="cell-border cell-color">
                                            {{ item.jobs[0].uploader }}
                                        </td>
                                        <td class="cell-border cell-color">
                                            {{ item.jobs[0].post_fb_user }}
                                        </td>
                                    </tr>

                                    <template v-for="(i,indexi) of item.jobs">
                                        <tr v-if="indexi > 0" :key="index+'-'+indexi">
                                            <td class="cell-border">
                                                <template v-if="i.fb_campaign_name">                                            
                                                    <v-btn
                                                    v-clipboard="i.fb_campaign_name"
                                                    @click="onCopy">
                                                    COPY
                                                </v-btn>
                                            </template>
                                            </td>
                                            <td class="cell-border">
                                                <template v-if="i.product_link">
                                                    <v-btn
                                                        v-clipboard="i.product_link"
                                                        @click="onCopy">
                                                        COPY
                                                    </v-btn>
                                                </template>
                                            </td>
                                            <td class="cell-border">
                                                {{ i.page }}
                                            </td>
                                            <td class="cell-border">
                                                {{ i.post_id }}
                                            </td>
                                            <td class="cell-border">
                                                <!-- <v-text-field v-model="i.marketing_note"></v-text-field>
                                                {{ i.marketing_note }} -->

                                                <v-edit-dialog
                                                    :return-value.sync="i.marketing_note"
                                                    @save="save(item,indexi,i.marketing_note)"
                                                    @cancel="cancel"
                                                    @open="open"
                                                    @close="close"
                                                    >
                                                    {{ i.marketing_note }}
                                                    <template v-slot:input>
                                                        <v-text-field
                                                        v-model="i.marketing_note"
                                                        label="Edit"
                                                        single-line
                                                        counter
                                                        ></v-text-field>
                                                    </template>
                                                </v-edit-dialog>
                                            </td>
                                            <td class="cell-border">
                                                <template v-if="i.banner_link">
                                                    <v-btn
                                                        v-clipboard="i.banner_link"
                                                        @click="onCopy">
                                                        COPY
                                                    </v-btn>
                                                </template>
                                            </td>
                                            <td class="cell-border">
                                                <v-menu
                                                :close-on-content-click="false"
                                                :nudge-width="200"
                                                offset-x
                                                persistent
                                                v-if="i.job_note"
                                                >
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-btn v-bind="attrs" v-on="on">
                                                            SHOW NOTE
                                                        </v-btn>
                                                    </template>
                                                    <v-card class="mx-auto" max-width="344" outlined>
                                                        {{ i.job_note }}
                                                    </v-card>
                                                </v-menu>
                                            </td>
                                            <td class="cell-border cell-color">
                                                {{ i.scaler }}
                                            </td>
                                            <td class="cell-border cell-color">
                                                {{ i.uploader }}
                                            </td>
                                            <td class="cell-border cell-color">
                                                {{ i.post_fb_user }}
                                            </td>
                                        </tr>
                                    </template>
                                </template>
                            </tbody>
                        </template>
                    </v-simple-table>

                    <v-snackbar
                    v-model="snack"
                    :timeout="3000"
                    :color="snackColor"
                    >
                    {{ snackText }}

                        <template v-slot:action="{ attrs }">
                            <v-btn
                            v-bind="attrs"
                            text
                            @click="snack = false"
                            >
                            Close
                            </v-btn>
                        </template>
                    </v-snackbar>
                </v-col>
            </v-row>
        </v-col>


        <v-snackbar v-model="snackbar">
        {{ informText }}

        <template v-slot:action="{ attrs }">
            <v-btn color="pink" text v-bind="attrs" @click="snackbar = false">
            Close
            </v-btn>
        </template>
        </v-snackbar>

        <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
        {{ snackText }}

        <template v-slot:action="{ attrs }">
            <v-btn v-bind="attrs" text @click="snack = false"> Close </v-btn>
        </template>
        </v-snackbar>
    </div>
</template>

<script>
    import axios from "axios";
    import moment from "moment-timezone"

    export default {
        name: "IdeaReport",

        data: () => ({
            snackbar: false,
            snack: false,
            snackColor: "",
            snackText: "",

            dates: [],
            filter: {
                byIdea:'',
                byProductType:'',
                byNiche:'',
                search: '',
                byStatus:[],
            },
            createdDatePicker: false,

            ideaReports:[],
            originalData:[],

            listIdeas:[],
            listProductTypes:[],
            listNiches:[],
            listStatus:[],
            informText:'',
            sortBy:'',
            sortType:'',
        }),

        computed: {
            dateRangeText() {
            return this.dates.join(" ~ ");
            },
        },

        watch:{

        },

        methods:{
            //modal edit
            async save (item,index,value) {
                //console.log("---item: ",item," - index: ",index," - value: ",value)
                var currentSession = await this.$root.$refs.App.currentSession(
                    "idea-report-loadData"
                );
                if (currentSession.accessToken) {
                    
                    await axios({
                        method: "PUT",
                        url: window.domain + "ideas_v2/update-marketing-note/" + item._id,
                        headers: { Authorization: currentSession.accessToken },
                        data: {
                            job_index: index,
                            marketing_note: value,
                        },
                    }).then((response) => {
                        console.log("response: ", response);
                        if (response.data.error_message != "") {
                            this.snack = true;
                            this.snackColor = 'error';
                            this.snackText = response.data.error_message;
                        } else {
                            this.snack = true;
                            this.snackColor = 'success';
                            this.snackText = 'Data saved';
                        }
                    })
                    .catch((error) => console.log(error));;
                }

            },
            cancel () {
                this.snack = true
                this.snackColor = 'error'
                this.snackText = 'Canceled'
            },
            open () {
                this.snack = true
                this.snackColor = 'info'
                this.snackText = 'Dialog opened'
            },
            close () {
                console.log('Dialog closed')
            },

            //end modal

            async loadData(){
                var currentSession = await this.$root.$refs.App.currentSession(
                    "idea-report-loadData"
                );
                if (currentSession.accessToken) {

                    let queryParams = {}

                    if (this.dates.length > 0) {
                        if (this.dates[0] > this.dates[1]) {
                        queryParams["created_from"] = this.dates[1];
                        queryParams["created_to"] = this.dates[0];
                        } else {
                        queryParams["created_from"] = this.dates[0];
                        queryParams["created_to"] = this.dates[1];
                        }
                    }

                    await axios
                    .get(window.domain + "/ideas_v2/report", {
                        headers: { Authorization: currentSession.accessToken },
                        params: queryParams,
                    }).then(response => {
                        console.log('response: ',response)
                        //this.ideaReports = response.data.ideas
                        this.listIdeas = response.data.data.idea_users
                        this.listProductTypes = response.data.data.product_type
                        this.listNiches = response.data.data.tags

                        let temp = new Set();

                        this.ideaReports = response.data.data.ideas.map(t => {
                            t.created_date = moment(t.created_date).format("YYYY-MM-DD HH:mm:ss");
                            
                            temp.add(t.status);
                            
                            t.niches = []

                            if(!t.product_code){
                                t.product_code = ''
                            }

                            if(t.product_tags.length > 0){
                                for(let i of t.product_tags){
                                    for(let j of this.listNiches){
                                        if(j._id == i){
                                            t.niches.push(j.tag_name)
                                        }
                                    }
                                }
                            }

                            return t;
                        })
                        this.listStatus = Array.from(temp)
                        console.log("this.ideaReports: ",this.ideaReports )
                        this.originalData = JSON.parse(JSON.stringify(this.ideaReports))
                    })
                }
            },

            filterData(){

                var data = this.originalData.filter(t => 
                t.product_title.toLowerCase().indexOf(this.filter.search.toLowerCase()) > -1 || 
                t.product_code.toLowerCase().indexOf(this.filter.search.toLowerCase()) > -1)

                //console.log("search: ",data)

                if(this.filter.byIdea){
                    data = data.filter(t => 
                    t.idea.indexOf(this.filter.byIdea) > -1 )
                    //console.log("idea: ",data)
                }

                if(this.filter.byProductType){
                    data = data.filter(t => 
                    t.product_type_name.indexOf(this.filter.byProductType) > -1 )
                    //console.log("product_type_name: ",data)
                }

                if(this.filter.byNiche){
                    data = data.filter(t => 
                    t.product_tags.indexOf(this.filter.byNiche) > -1 )
                    //console.log("product_tags: ",data)
                }

                if(this.filter.byStatus.length > 0){
                    let temp = [];

                    for(let stt of this.filter.byStatus){
                        let filter = data.filter(t => t.status.indexOf(stt) > -1 )
                        if(filter.length > 0){
                            filter.map(x => {
                                temp.push(x)
                            })
                        }
                    }

                    data = temp
                    // data = data.filter(t => 
                    // t.status.indexOf(this.filter.byStatus) > -1 )
                    //console.log("product_tags: ",data)
                }

                this.ideaReports = data
                //return data
            },

            clearFilter(){
                this.filter = {
                    byIdea:'',
                    byProductType:'',
                    byNiche:'',
                    search: '',
                    byStatus:'',
                }
                this.$forceUpdate();
                
                this.ideaReports = JSON.parse(JSON.stringify(this.originalData))
            },

            sleep(ms) {
            return new Promise((resolve) => setTimeout(resolve, ms));
            },

            async onCopy() {
                this.snackbar = true;
                this.informText = "Link/Text was copied successful";
                await this.sleep(3000);
                this.informText = "";
                this.snackbar = false;
            },

            sortData(col) {
                this.sortBy = col;
                if (this.sortType == null) {
                    this.sortType = false;
                } else {
                    this.sortType = !this.sortType;
                }

                if (this.sortType == false)
                    this.ideaReports.sort((a, b) => (a[col] > b[col] ? 1 : -1));
                else this.ideaReports.sort((a, b) => (a[col] < b[col] ? 1 : -1));
                
                console.log('this.ideaReports: ',this.ideaReports)
            },
        },

        mounted(){

        }
    }
</script>

<style lang="scss" scoped>
.cell-border{
    border: thin solid rgba(0, 0, 0, 0.12);
}

.cell-color{
    background-color: #D9EAD3;
}

.resize-div{
    resize: both;
  overflow: auto;
  display: block;
}

</style>